import Skeleton from '@mui/material/Skeleton';

const rootCss = ({ spacing }) => ({
  '.LF-block + .LF-block': { marginTop: spacing(4) },
});

export default function LoadingFallback() {
  // const { questionType } = props;
  return (
    <div css={rootCss}>
      {[...Array(4)].map((_, i) => (
        <Skeleton key={i} className="LF-block" variant="rectangular" />
      ))}
    </div>
  );
}
